export default {
  /*
  freeBus: {
    'type': 'FeatureCollection',
    'features': [
      {
        'type': 'Feature',
        'geometry': {
          'type': 'LineString',
          'coordinates': [
            [-105.00341892242432, 39.75383843460583],
            [-105.0008225440979, 39.751891803969535]
          ]
        },
        'properties': {
          'popupContent': 'This is a free bus line that will take you across downtown.',
          'underConstruction': false
        },
        'id': 1
      },
      {
        'type': 'Feature',
        'geometry': {
          'type': 'LineString',
          'coordinates': [
            [-105.0008225440979, 39.751891803969535],
            [-104.99820470809937, 39.74979664004068]
          ]
        },
        'properties': {
          'popupContent': 'This is a free bus line that will take you across downtown.',
          'underConstruction': true
        },
        'id': 2
      },
      {
        'type': 'Feature',
        'geometry': {
          'type': 'LineString',
          'coordinates': [
            [-104.99820470809937, 39.74979664004068],
            [-104.98689651489258, 39.741052354709055]
          ]
        },
        'properties': {
          'popupContent': 'This is a free bus line that will take you across downtown.',
          'underConstruction': false
        },
        'id': 3
      }
    ]
  },
  */
  schoolLocation: {
    'type': 'FeatureCollection',
    'features': [
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.538820,
            11.470450
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '05020307902',
          'schNameEN': 'Kampong Speu',
          'schNameKH': 'វិទ្យាល័យកំពុងស្ពឺ',
          'schType': 4,
          'schDir': 'អេង ថាវុធ',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 1
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.529190,
            11.467050
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '15010101001',
          'schNameEN': 'Serey Matha',
          'schNameKH': '',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 2
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.317800,
            11.279880
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': 'Chomkar nornong',
          'schNameKH': 'ចំការនរនោង',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.531550,
            11.468800
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': 'POE',
          'schNameKH': '',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.532110,
            11.468040
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': 'TTC',
          'schNameKH': '',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.533650,
            11.468380
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': 'Library',
          'schNameKH': '',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.527771,
            11.466246
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': 'Holiday Guest House',
          'schNameKH': '',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.525517,
            11.464963
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': 'Kheam Ra Resturance',
          'schNameKH': '',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.531680,
            11.467150
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': 'Pheng Ly Guest House',
          'schNameKH': '',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.531820,
            11.467110
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': 'Tessco Coffe',
          'schNameKH': '',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.542890,
            11.467460
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': 'Dream Boutique Guest House',
          'schNameKH': '',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.533130,
            11.468480
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': '',
          'schNameKH': 'បឋមសិក្សាសន្តិរាម',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.525760,
            11.464620
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': '',
          'schNameKH': 'ផេងអាន Resturance',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.525715,
            11.464636
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': '',
          'schNameKH': 'ហាងបាយ ឌីឡា',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      },
      {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.539958,
            11.472690
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': '',
          'schNameKH': 'អំពែភ្នំ',
          'schType': 2,
          'schDir': '',
          'enT': 100,
          'enF': 34,
          'teT': 10,
          'teF': 5
        },
        'id': 3
      }
    ]
  },
  coorsField: {
    'type': 'Feature',
    'properties': {
      'popupContent': 'Coors Field'
    },
    'geometry': {
      'type': 'Point',
      'coordinates': [-104.99404191970824, 39.756213909328125]
    }
  }
}
/*
     {
        'geometry': {
          'type': 'Point',
          'coordinates': [
            104.893486,
            11.566880
          ]
        },
        'type': 'Feature',
        'properties': {
          'schCode': '',
          'schNameEN': '',
          'schNameKH': '',
          'schType': ,
          'schDir': '',
          'enT': ,
          'enF': ,
          'teT': ,
          'teF': 1
        },
        'id': 2
      }
*/
